import * as React from "react";
const SvgDocumentImageFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 2a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm1 10.07L12 17l-3-2-3 5h12.1zM9 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4", clipRule: "evenodd" }));
export default SvgDocumentImageFill;
